import api from './api';

const smsService = {
  // Envoyer un SMS
  sendSMS: async (phoneNumber, message) => {
    const response = await api.post('/sms/send', { phoneNumber, message });
    return response.data;
  },

  // Envoyer des SMS groupés
  sendBulkSMS: async (phoneNumbers, message) => {
    const response = await api.post('/sms/send-bulk', { phoneNumbers, message });
    return response.data;
  },

  // Envoyer un SMS à tous les utilisateurs d'un module
  sendSMSToModule: async (module, message) => {
    const response = await api.post('/sms/send-to-module', { module, message });
    return response.data;
  },
};

export default smsService;
